import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-most-login',
  templateUrl: './most-login.component.html',
  styleUrls: ['./most-login.component.scss']
})
export class MostLoginComponent implements OnInit {
  keySubscription!:Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router:Router,
    private global:GlobalService
  ) { }

  ngOnInit(): void { 
    this.keySubscription = fromEvent<KeyboardEvent>(document, 'keydown')
    .subscribe(event => {
      if(event.key == 'Enter'){
        event.preventDefault()
        this.navigateToLoginUrl()
      }
    })    
   }
  
  navigateToLoginUrl(){
    this.router.navigate(['/auth/login'] , {queryParams :{
      next : this.data
    }})
    setTimeout(() => {
      this.global.scrollTop()
    }, 200);
  }
  ngOnDestroy(): void {
    this.keySubscription.unsubscribe()
  }
}
